export const menubar = {
  about: "about",
  exp: "exp",
  project: "project",
  personal: "personal",
} as const;
